import React from "react";
import style from "./index.module.scss";
import { Button, message, Modal, Tooltip } from "antd";
import ListStatus from "../ListStatus";
import ListStatics from "../ListStatics";
import ListDropDown from "../ListDropDown";
import ListLinks from "../ListLinks";
import { ExerciseItem, ExerciseStatus, removeExercise } from "service/exercise";
import useRequest from "utils/useRequest";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import useVerifyExercise from "utils/useVerifyExercise";
import BriefInfo from "../BriefInfo";
import ViewPublishLog from "../ViewPublishLog";

interface ListItemProp {
    item: ExerciseItem;
    updateList: () => void;
    gotoDetail: (exerciseId: number, params?: StringMap) => void;
}

export default function ListItem({
    item,
    updateList,
    gotoDetail
}: ListItemProp) {
    const status =
        item.exerciseCount < 1 && item.exerciseStatus === 0
            ? ExerciseStatus.NoExercise
            : item.exerciseStatus;
    const [, , remove] = useRequest(() => removeExercise(item.id), {
        autoStart: false
    });
    const { onVerify } = useVerifyExercise();

    // onVerify 方法第二个参数
    const verifyStatusList = [
        {
            verifyStatus: ExerciseStatus.del,
            noticeContent: "练习活动已删除，请刷新页面"
        }
    ];

    function onDelete() {
        Modal.confirm({
            getContainer,
            title: `删除“${item.description}”？`,
            content:
                "练习活动删除后，该活动中的所有练习数据都将被删除且不可恢复，确定要删除吗?",
            onOk: () =>
                remove().then(() => {
                    updateList?.();
                    ResultMessage.success("删除成功！");
                })
        });
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    async function onClick() {
        try {
            const executeContinue = await onVerify(item.id, verifyStatusList);
            if (executeContinue) onDelete();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={item.description}>
                    {item.description}&nbsp;&nbsp;
                </Tooltip>
                <ListStatus state={status} />
            </h1>

            <div className={style.info}>
                {![
                    ExerciseStatus.NoExercise,
                    ExerciseStatus.NotStarted
                ].includes(status) && <ViewPublishLog id={item.id} />}

                <BriefInfo item={item} status={status} />
            </div>

            <div className={`${style.tools} `}>
                {status === ExerciseStatus.done && (
                    <ListStatics
                        exerciseId={item.id}
                        exerciseAllCount={item.exerciseAllCount}
                        noJudgeCount={item.noJudgeCount}
                        judgeCount={item.judgeCount}
                        noJoinInExerciseCount={item.noJoinInExerciseCount}
                        gotoDetail={gotoDetail}
                    />
                )}

                <ListLinks
                    paperId={item.id}
                    status={status}
                    weekTimeId={item.weekTimeId}
                    exerciseId={item.id}
                    onChange={updateList}
                />

                {status !== ExerciseStatus.done && (
                    <ListDropDown
                        id={item.id}
                        updateList={updateList}
                        status={status}
                        onDelete={onDelete}
                    />
                )}

                {status === ExerciseStatus.done && (
                    <Button
                        type="link"
                        onClick={onClick}
                        style={{ fontSize: "12px" }}>
                        删除
                    </Button>
                )}
            </div>
        </div>
    );
}
